import { DeptItem, MemberItem, RoleItem } from '@fx-ui/jdy-design-biz';
import { SuiteId } from '@libs/shared';

export enum RangeType {
    Partial = 0,
    All = 1
}

export interface CorpGroupConfig {
    _id: string;
    tenant_id: string;
    dept_range: DeptItem[];
    dept_range_type: RangeType;
    group_type: CorpGroupType; // 管理组类型
    members: (MemberItem & { isFilterData?: boolean })[];
    name: string;
    role_range: RoleItem[];
    role_range_type: RangeType;
    seq: number;
    suite_id: SuiteId;
    op: {
        memberRead: boolean;
        memberWrite: boolean;
        roleWrite: boolean;
        roleRead: boolean;
        corpCoopManage: boolean;
        /** 外部成员是否可见可管理 */
        externalMemberManage: boolean;
        /** 外部角色是否可见可管理 */
        externalRoleManage: boolean;
    };
}

export enum CorpGroupType {
    /* 系统管理组 */
    System = -1,
    /* 通讯录管理组 */
    Contacts = 1
}
